import Loading from 'components/Loading';
import styled from 'styled-components';
import RenderAfterNavermapsLoaded from 'utils/RenderAfterNavermapsLoaded';
import LikeComplexMap from './LikeComplexMap';

function LikeComplexMapHome() {
  return (
    <>
      <Container>
        <RenderAfterNavermapsLoaded
          ncpClientId={process.env.REACT_APP_NAVER_MAP_KEY}
          error={<Loading />}
          loading={<Loading />}
        >
          <LikeComplexMap />
        </RenderAfterNavermapsLoaded>
      </Container>
    </>
  );
}

export default LikeComplexMapHome;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
`;
